module.exports = __webpack_public_path__ + "img/palaze-black.b7bfe964.svg";